import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { WorkAction } from '../../../shopfloor/workcenters/capability/capabilities/work-action'
import { Action } from '../action'
import { ActionService } from '../action.service'

@Directive({
  selector: '[appActionSelect]',
})
export class ActionSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public disabledWorkActions: WorkAction[] = []
  private select = inject<ElderSelectComponent<Action>>(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const actionService = inject(ActionService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'process.actions.action'
    this.select.isOptionDisabledFn = (action) =>
      this.disabledWorkActions.some((wa) => wa.action === action.id)
    this.select.dataSource = actionService
    this.select.sorts = [new Sort('id', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public clear(): void {
    this.select.clear(null)
  }
}
